import { useState } from "react";

interface ArticleActionsProps {
  baseLikes: number;
}

export default function ArticleActions({ baseLikes }: ArticleActionsProps) {
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);
  const [message, setMessage] = useState("");

  const flash = (text: string) => {
    setMessage(text);
    window.setTimeout(() => setMessage(""), 2600);
  };

  const handleLike = () => {
    setLiked((prev) => {
      flash(prev ? "已取消点赞" : "感谢支持，已标记为有用");
      return !prev;
    });
  };

  const handleSave = () => {
    setSaved((prev) => {
      flash(prev ? "已取消收藏" : "已加入收藏，可在个人中心查看");
      return !prev;
    });
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      flash("链接已复制，分享给朋友一起围观");
    } catch {
      flash("复制失败，请手动复制地址栏链接");
    }
  };

  const handleReport = () => {
    flash("已收到举报，我们会在 24 小时内完成核实");
  };

  return (
    <div className="mt-8 flex flex-col gap-3 border-y border-background-200 py-5 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={handleLike}
          aria-pressed={liked}
          className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md border px-4 py-2 text-sm font-medium transition-colors ${
            liked
              ? "border-primary-500 bg-primary-50 text-primary-700"
              : "border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          <i className={liked ? "ri-thumb-up-fill" : "ri-thumb-up-line"} aria-hidden="true" />
          有用 {liked ? baseLikes + 1 : baseLikes}
        </button>
        <button
          type="button"
          onClick={handleSave}
          aria-pressed={saved}
          className={`inline-flex items-center gap-2 whitespace-nowrap rounded-md border px-4 py-2 text-sm font-medium transition-colors ${
            saved
              ? "border-secondary-500 bg-secondary-50 text-secondary-700"
              : "border-background-300 text-foreground-700 hover:border-secondary-300 hover:text-secondary-700"
          }`}
        >
          <i className={saved ? "ri-bookmark-fill" : "ri-bookmark-line"} aria-hidden="true" />
          {saved ? "已收藏" : "收藏"}
        </button>
        <button
          type="button"
          onClick={handleCopy}
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-link" aria-hidden="true" />
          复制链接
        </button>
        <button
          type="button"
          onClick={handleReport}
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-flag-line" aria-hidden="true" />
          举报不实
        </button>
      </div>
      <p className="min-h-[20px] text-xs text-foreground-600" role="status" aria-live="polite">
        {message}
      </p>
    </div>
  );
}